import { render, staticRenderFns } from "./slide-out.vue?vue&type=template&id=5511a5a0&scoped=true"
import script from "./slide-out.vue?vue&type=script&lang=js"
export * from "./slide-out.vue?vue&type=script&lang=js"
import style0 from "./slide-out.vue?vue&type=style&index=0&id=5511a5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5511a5a0",
  null
  
)

export default component.exports